export default __webpack_public_path__ + "static/media/Abhijeet Vichare.c8e4bc0f.jpg";